import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

// Per-location inventory: purchase ledger + consumption reporting.
const base = (restaurantId, locationId) =>
  `${API_URL}/users/restaurant/${restaurantId}/locations/${locationId}/inventory`;

// ---- Purchase ledger ------------------------------------------------------

export const listPurchases = async (restaurantId, locationId, ingredientId = null) => {
  const q = ingredientId ? `?ingredient_id=${ingredientId}` : '';
  const { data } = await axios.get(`${base(restaurantId, locationId)}/purchases/${q}`);
  return data?.results || [];
};

export const createPurchase = async (restaurantId, locationId, payload) => {
  const { data } = await axios.post(`${base(restaurantId, locationId)}/purchases/`, payload);
  return data?.data;
};

export const updatePurchase = async (restaurantId, locationId, id, payload) => {
  const { data } = await axios.put(`${base(restaurantId, locationId)}/purchases/${id}/`, payload);
  return data?.data;
};

export const deletePurchase = async (restaurantId, locationId, id) => {
  const { data } = await axios.delete(`${base(restaurantId, locationId)}/purchases/${id}/`);
  return data;
};

// ---- Reporting ------------------------------------------------------------

// One row per ingredient: total purchased, total consumed, #orders, last purchase.
export const getInventorySummary = async (restaurantId, locationId) => {
  const { data } = await axios.get(`${base(restaurantId, locationId)}/summary/`);
  return data?.results || [];
};

// Daily purchase + consumption breakdown for a single ingredient.
export const getItemHistory = async (restaurantId, locationId, ingredientId) => {
  const { data } = await axios.get(`${base(restaurantId, locationId)}/items/${ingredientId}/history/`);
  return data || { purchases: [], consumption: [] };
};
